import _ from 'lodash';

export const isEmptyCriteria = criteria => _.get(criteria, 'items.length', 0) === 0;
